import classNames from 'classnames';
import * as React from 'react';
import { Button } from 'palette/Button';
import { Size as TButtonSize } from 'palette/Button/constants';
import type { Color } from 'palette/Colors';
import { Icon } from 'palette/Icon';
import { IconName } from 'palette/Icon/constants';
import { useProductCardContext } from 'palette/ProductCard';
import { CARD_THEMES } from 'palette/ProductCard/constants';
import { Transition } from 'palette/Transition';

import './FavoriteButton.scss';

interface FavoriteButtonsProps {
    className?: string;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    isSelected?: boolean;
    isTransparent: boolean;
    size?: TButtonSize;
    ariaLabel?: string;
}

function FavoriteButton({
    className,
    onClick,
    isSelected,
    isTransparent,
    size,
    ariaLabel,
}: FavoriteButtonsProps) {
    const buttonClassNames = classNames(
        'palette-product-card-favorite-button', {
            'palette-product-card-favorite-button--transparent': isTransparent,
            'palette-product-card-favorite-button--selected': isSelected,
        }, className,
    );
    const { theme } = useProductCardContext();

    const borderColor: Color = theme === CARD_THEMES.dark ? 'grey-100' : 'grey-800';
    const iconName: IconName = isSelected ? 'palette_heart_full' : 'palette_heart';
    const iconColor: Color = isSelected ? 'red-800' : borderColor;

    return (
        isTransparent ? (
            <Transition
                appear
                property="transform"
                timeout="quick"
            >
                <button
                    aria-label={ariaLabel}
                    className={buttonClassNames}
                    onClick={onClick}
                >
                    <Icon
                        color={iconColor}
                        name={iconName}
                        size="small"
                    />
                </button>
            </Transition>
        ) : (
            <Button
                className={buttonClassNames}
                iconColor={iconColor}
                iconName={iconName}
                size={size}
                theme="secondary"
                onClick={onClick}
            />
        )
    );
}

export default FavoriteButton;
